module.exports = ".row {\n  margin-right: 0;\n  margin-left: 0; }\n\n.modal-inline-error {\n  margin: 0; }\n"